export interface NotificationOverviewInterface {
  count: number;
  userHasUnseenNotifications: boolean;
}
